import { Filter, RotateCcw, Search, ListOrdered, Download, Settings, Plus } from "lucide-react";
import { useState, useEffect } from "react";
import { StatusFilterPhotoMeter, PhotoMeterItem, TagihanItem } from "../../../../model/Hublang";
import { fetchGetKoreksiMeterPelangganAll, fetchGetKoreksiMeterPelanggan } from "../../../../controller/dashboard/Cekmeter";
import { CSV } from "../../../../util/ExportFile";

export const Pelanggan = () => {
    const [showEditModal, setShowEditModal] = useState(false);
    const [selectedTagihan, setSelectedTagihan] = useState<TagihanItem | null>(null);
    const [selectedPhotoMeter, setSelectedPhotoMeter] = useState<PhotoMeterItem | null>(null);

    const [loading, setLoading] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10); // bisa default 
    const [statusFilter, setStatusFilter] = useState<StatusFilterPhotoMeter>({
        nama: 'all',
        nsb: 'all',
        kecamatan: 'all',
        desa: 'all',
        klasf: 'all',
        pelanggan: 'all',
        status: 'all',
        pakai: 'all',
        tahun: 'all'
    });

    const [statusLength, setStatusLength] = useState('10');
    const [showDetailModal, setShowDetailModal] = useState(false);
    const [photoMeterData, setPhotoMeterData] = useState<PhotoMeterItem[]>([]);
    const uniqueNsb = Array.from(new Set(photoMeterData.map(item => item.nsb))).filter(Boolean);
    const uniqueKecamatan = Array.from(new Set(photoMeterData.map(item => item.kecamatan))).filter(Boolean);
    const uniqueDesa = Array.from(new Set(photoMeterData.map(item => item.desa))).filter(Boolean);
    const uniqueKlas = Array.from(new Set(photoMeterData.map(item => item.klasf))).filter(Boolean);
    const uniquePelanggan = Array.from(new Set(photoMeterData.map(item => item.pelanggan))).filter(Boolean);
    const uniqueStatus = Array.from(new Set(photoMeterData.map(item => item.status))).filter(Boolean).sort((a, b) => Number(a) - Number(b));


    const filteredPhotoMeters = photoMeterData.filter(plg => {
        const matchesSearch =plg.nama.toLowerCase().includes(searchTerm.toLowerCase()) ||
        plg.nama.includes(searchTerm) ||
        plg.nsb.includes(searchTerm) ||
        plg.kecamatan.includes(searchTerm) ||
        plg.desa.includes(searchTerm) ||
        plg.klasf.includes(searchTerm) ||
        plg.pelanggan.includes(searchTerm) ||
        plg.status.includes(searchTerm) ||
        plg.pakai.includes(searchTerm) ||
        plg.tahun.includes(searchTerm)

        const matchesStatus = 
        (statusFilter.status === 'all' || plg.status === statusFilter.status) &&
        (statusFilter.nama === 'all' || plg.nama === statusFilter.nama) &&
        (statusFilter.nsb === 'all' || plg.nsb === statusFilter.nsb) &&
        (statusFilter.kecamatan === 'all' || plg.kecamatan === statusFilter.kecamatan) &&
        (statusFilter.pakai === 'all' || plg.pakai === statusFilter.pakai) &&
        (statusFilter.klasf === 'all' || plg.klasf === statusFilter.klasf) &&
        (statusFilter.pelanggan === 'all' || plg.pelanggan === statusFilter.pelanggan) &&
        (statusFilter.desa === 'all' || plg.desa === statusFilter.desa) &&
        (statusFilter.tahun === 'all' || plg.tahun === statusFilter.tahun)

        return matchesSearch && matchesStatus;
    });

    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentPhotoMeters = filteredPhotoMeters.slice(indexOfFirstItem, indexOfLastItem);
    let totalPages = itemsPerPage > 0 ? Math.ceil(filteredPhotoMeters.length / itemsPerPage) : 0;
    const pageNumbers = totalPages > 0 ? Array.from({ length: totalPages }, (_, i) => i + 1) : [];

    const initDataPhotoMeter = async () => { 
        setLoading(true); // Set loading state ke true sebelum memulai fetch
        try {
            const res = await fetchGetKoreksiMeterPelangganAll(); // Panggil API
            if (res.status === 200 && Array.isArray(res.data)) {

                const today = new Date();
                today.setHours(0, 0, 0, 0);

                const processedData = res.data.map((item: any) => ({
                    no: 0,
                    nama: item.NAMA || "Tidak ada data",
                    nsb: item.NSB || "Tidak ada data",
                    kecamatan: item.KECAMATAN || "Tidak ada data",
                    desa: item.DESA || "Tidak ada data",
                    klasf: item.KLASF || "Tidak ada data",
                    pelanggan: item.PELANGGAN || "Tidak ada data",
                    status: item.STATUS || "Tidak ada data",
                    pakai: item.PAKAI || "Tidak ada data",
                    tahun: item.TAHUN || "Tidak ada data",
                }));

                const sortedData = processedData;
                setPhotoMeterData(sortedData);
            } else {
                console.error("Invalid response data:", res.data);
                setPhotoMeterData([]);
            }
        } catch (error) {
            console.error("Error fetching data:", error);
            setPhotoMeterData([]);
        } finally {
            setLoading(false);
        }
    };

    const handleShowDetail = (pm : PhotoMeterItem) => {
        setSelectedPhotoMeter(pm);
        setShowDetailModal(true);
    }

    const handleShowEdit = (tagihan?: any) => {
        setSelectedTagihan(tagihan);
        setShowEditModal(true);
        setShowDetailModal(false);
    }

    const ExportCSV = (data : any) => {
        return (
            <button 
                onClick={async () => {
                    try {
                       await CSV(data, "Export_PhotoMeter");
                    } catch (error) {
                        console.error("Error exporting CSV:", error);
                    }
                }}
                className="flex items-center px-4 py-2 text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200 transition-colors">
                <Download className="w-4 h-4 mr-2" />
                { "Export" }
            </button>
        )
    }
    
    const RenderTablePhotoMeterPelanggan = ({ filteredData, onOpenDetail }: { 
        filteredData: PhotoMeterItem[] | null; 
        onOpenDetail : (employee: PhotoMeterItem) => void;
    }) => (
      <>
        {
          filteredData && filteredData.length > 0 ? (
            filteredData.map((plg, idx) => (
              <tr key={idx} className="bg-gray-50 hover:bg-gray-200 transition-colors">
                <td className="px-6 py-4 whitespace-nowrap">
                    {idx + 1}
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                    {plg.nama}
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                    {plg.nsb}
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                  {plg.kecamatan}
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                    {plg.desa}
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                    {plg.klasf}
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                    {plg.pelanggan}
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                    {plg.status}
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                    {plg.pakai}
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                    {plg.tahun}
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                    <button onClick={() => { onOpenDetail(plg) }} className="flex items-center px-4 py-2 text-white bg-blue-600 rounded-lg hover:bg-blue-700 transition-colors"
                    ><Settings /></button>
                    {/* <button onClick={() => { onOpenDetail(plg) }} className="flex items-center px-4 py-2 text-white bg-gray-600 rounded-lg hover:bg-gray-700 transition-colors"
                    ><Plus /></button> */}
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={18} className="text-center py-4 text-gray-500">
                Tidak ada data
              </td>
            </tr>
          )
        }
      </>
    );
    
    const DetailPreviewModal = ({ pelangganPMDetail, stateShowModal }: { 
        pelangganPMDetail: PhotoMeterItem | null; 
        stateShowModal: (show: boolean) => void | false;
    }) => {
        const [data, setData] = useState<any>({ data: [] });
        const [loadingData, setLoadingData] = useState<boolean>(false);
    
        useEffect(() => {
            const fetchData = async () => {
                setLoadingData(true);
                const result = await fetchGetKoreksiMeterPelanggan(pelangganPMDetail?.nsb || '');
                setData(result);
                setLoadingData(false);
            };
            fetchData();
        }, [pelangganPMDetail]);
    
        
    
        const sortedData = data.data.slice().sort((a : any, b : any) => {
            if (a.TAHUN !== b.TAHUN) return b.TAHUN - a.TAHUN;
            return b.BULAN - a.BULAN;
          });
    
        return(
            <>
            <div className="fixed inset-0 z-50 flex items-center justify-center bg-gray-800 bg-opacity-50">
                <div className="bg-white rounded-xl shadow-2xl w-full max-w-9xl mx-4 p-4 overflow-hidden">
                    <div className="flex items-center justify-between mb-6">
                        <div>
                            <h3 className="text-xl font-semibold text-gray-800">Detail Pelanggan : {pelangganPMDetail?.nama} </h3>
                            <div className="text-xl font-semibold text-gray-500">Pelanggan : {pelangganPMDetail?.pelanggan}</div>
                            <div className="text-xl font-semibold text-gray-500">Klasf : {pelangganPMDetail?.klasf}</div>
                        </div>
                        <button
                            onClick={() => stateShowModal(false)}
                            className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
                            >
                            ✕
                        </button>
                    </div>
                
                    <div className="space-y-4 overflow-y-auto max-h-[70vh]">
                        <table className="table-auto min-w-full max-w-screen-lg divide-y divide-gray-200">
                            <thead className="bg-gray-50">
                                <tr>
                                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">NO</th>
                                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">PERIODE</th>
                                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">KLASF</th>
                                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">MLALU</th>
                                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">MKINI</th>
                                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">PAKAI</th>
                                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">VOL.</th>
                                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">H.AIR</th>
                                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">ADM</th>
                                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">DENDA</th>
                                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">SUBSIDI</th>
                                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">TOTAL</th>
                                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">TOTAL BAYAR</th>
                                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"></th>
                                </tr>
                            </thead>
                            <tbody>
                    { sortedData && sortedData.length > 0 ? (
                                <>
                                  {sortedData.map((tagihan: any, idx: number) => (
                                      <tr key={idx} className="hover:bg-gray-100 transition-colors">
                                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{idx + 1}</td>
                                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{tagihan.BULAN} - {tagihan.TAHUN}</td>
                                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{tagihan.KLAS}</td>
                                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{tagihan.MLALU}</td>
                                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{tagihan.MKINI}</td>
                                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{tagihan.PAKAI}</td>
                                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{tagihan.VOLUME}</td>
                                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{tagihan.HAIR}</td>
                                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{tagihan.ADM}</td>
                                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{tagihan.DENDA}</td>
                                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{tagihan.SUBSIDI}</td>
                                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{tagihan.TOTAL}</td>
                                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{tagihan.TOTAL_BYR}</td>
                                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                          <button
                                          onClick={async () => { setSelectedTagihan(tagihan); handleShowEdit(tagihan); }}
                                          className="flex items-center px-4 py-2 text-white bg-blue-600 rounded-lg hover:bg-blue-700 transition-colors"
                                          >
                                              <Settings />
                                              </button>
                                          </td>
                                      </tr>
                                  ))}
    
                                  {/* 🔹 Tambahkan baris total */}
                                  <tr className="bg-gray-100 font-semibold text-gray-900">
                                      <td colSpan={7} className="px-6 py-3 text-right">
                                      TOTAL
                                      </td>
                                      <td className="px-6 py-3">
                                          {sortedData.reduce((sum: number, t: any) => sum + (Number(t.HAIR) || 0), 0).toLocaleString()}
                                      </td>
                                      <td className="px-6 py-3">
                                          {sortedData.reduce((sum: number, t: any) => sum + (Number(t.ADM) || 0), 0).toLocaleString()}
                                      </td>
                                      <td className="px-6 py-3">
                                          {sortedData.reduce((sum: number, t: any) => sum + (Number(t.DENDA) || 0), 0).toLocaleString()}
                                      </td>
                                      <td className="px-6 py-3">
                                          {sortedData.reduce((sum: number, t: any) => sum + (Number(t.SUBSIDI) || 0), 0).toLocaleString()}
                                      </td>
                                      <td className="px-6 py-3">
                                          {sortedData.reduce((sum: number, t: any) => sum + (Number(t.TOTAL) || 0), 0).toLocaleString()}
                                      </td>
                                      <td className="px-6 py-3">
                                          {sortedData.reduce((sum: number, t: any) => sum + (Number(t.TOTAL_BYR) || 0), 0).toLocaleString()}
                                      </td>
                                      <td></td>
                                  </tr>
                                </>
                                ) : (
                                <tr>
                                    { loadingData ?  
                                        <td colSpan={12} className="text-center py-4 text-gray-500">
                                            Sedang Loading . . . 
                                        </td>
                                        :
                                        <td colSpan={12} className="text-center py-4 text-gray-500">
                                            Tidak ada data tagihan 
                                        </td>
                                    }
                                </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
    
                </div>
            </div>
            </>
        );
    }

    type Props = {
        show: boolean;
        tagihan: TagihanItem | null;
        pelanggan: PhotoMeterItem | null;
        onClose: () => void;
        onSubmit: (data: TagihanItem) => void;
    };

    const fetchPutKoreksiPelanggan = async (nsb? : string , form? : any) => {
      form = { ...form, NSB : nsb };
      let key = process.env.REACT_APP_API_KEY || '';
      var myHeaders = new Headers();
      myHeaders.append("Authorization", key); 
      const url = process.env.REACT_APP_API_URL + "/hublang/koreksi-meter/pelanggan";    
      try {
          const response = await fetch(url,{
              method: 'POST',
              headers: myHeaders,
              redirect: 'follow',
              body: JSON.stringify(form) ?? null
          })

          const result = await response.json();
          return { status: result.status, data: result.data };

      } catch (error) {
          console.error('Error:', error);
          return { status: 500, message: "Terjadi kesalahan pada server", data: [] };
      }
    }
    
    const EditModal = ({ show, tagihan, pelanggan, onClose, onSubmit }: Props) => {
        const [form, setForm] = useState<TagihanItem>({
          MLALU: "",
          MKINI: "",
          PAKAI: "",
          VOLUME: "",
          HAIR: "",
          ADM: "",
          DENDA: "",
          SUBSIDI: "",
          TOTAL: "",
          TOTAL_BYR: ""
        });

        const parseNumber = (v?: string) => {
            if (!v) return 0;
            // hilangkan semua selain digit dan tanda minus, dan ganti koma dengan titik bila ada desimal
            const cleaned = String(v).replace(/[, ]+/g, "").replace(/[^0-9.-]/g, "");
            const n = parseFloat(cleaned);
            return Number.isFinite(n) ? n : 0;
        };
      
        // sinkronkan ketika modal dibuka atau tagihan berubah
        useEffect(() => {
          if (show && tagihan) {
            setForm({
              ...tagihan,
              MLALU: tagihan.MLALU ?? "",
              MKINI: tagihan.MKINI ?? "",
              PAKAI: tagihan.PAKAI ?? "",
              VOLUME: tagihan.VOLUME ?? "",
              HAIR: tagihan.HAIR ?? "",
              ADM: tagihan.ADM ?? "",
              DENDA: tagihan.DENDA ?? "",
              SUBSIDI: tagihan.SUBSIDI ?? "",
              TOTAL: tagihan.TOTAL ?? "",
              TOTAL_BYR : tagihan.TOTAL_BYR ?? "",
            });
          }
        }, [show, tagihan]);

        useEffect(() => {
          const hair = parseNumber(form.HAIR);
          const adm = parseNumber(form.ADM);
          const denda = parseNumber(form.DENDA);
          const subsidi = parseNumber(form.SUBSIDI);
        
          const total = hair + adm;
          const total_bayar = total + denda - subsidi;
        
          const totalStr = String(total);
          const totalByrStr = String(total_bayar);
        
          // update hanya kalau salah satu berubah (hindari loop & re-render berlebih)
          if (form.TOTAL !== totalStr || form.TOTAL_BYR !== totalByrStr) {
            setForm((prev) => ({ ...prev, TOTAL: totalStr, TOTAL_BYR: totalByrStr }));
          }
        }, [form.HAIR, form.ADM, form.DENDA, form.SUBSIDI]);
        
            
        if (!show) return null;

        const handleSave = async (nsb? : string) => {
          // pastikan TOTAL sinkron (sekali lagi)
          const hair = parseNumber(form.HAIR);
          const adm = parseNumber(form.ADM);
          const denda = parseNumber(form.DENDA);
          const subsidi = parseNumber(form.SUBSIDI);
          const total = hair + adm;
          const total_bayar = total + denda - subsidi;
          const payload: TagihanItem = { ...form, TOTAL: String(total), TOTAL_BYR: String(total_bayar) };
      
          // panggil fungsi update (sesuaikan nama jika di projectmu beda)
          try {
            await fetchPutKoreksiPelanggan(nsb, payload);
            onClose();
          } catch (err) {
            console.error("Gagal simpan:", err);
          }
        };
      
        return (
          <div className="fixed inset-0 z-50 flex items-center justify-center bg-gray-800 bg-opacity-50 p-4">
            <div className="bg-white rounded-xl shadow-2xl w-full max-w-2xl p-6">
              <header className="flex items-start justify-between mb-4">
                <div>
                  <h3 className="text-lg font-semibold text-gray-800">
                    Edit Tagihan {tagihan?.BULAN} - {tagihan?.TAHUN}
                    <br />
                    {pelanggan?.nama}
                  </h3>
                </div>
                <button onClick={onClose} className="p-2 rounded-full hover:bg-gray-100">
                  ✕
                </button>
              </header>
      
              <div className="space-y-4">
                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <label className="text-xs text-gray-500 uppercase">MLALU</label>
                    <input value={form.MLALU ?? ""}
                        onChange={(e) => { setForm({ ...form, MLALU: e.target.value,})}}
                        className="w-full border rounded px-3 py-2 text-sm" />
                  </div>
      
                  <div>
                    <label className="text-xs text-gray-500 uppercase">MKINI</label>
                    <input value={form.MKINI ?? ""}
                        onChange={(e) => { setForm({ ...form, MKINI: e.target.value,})}}
                        className="w-full border rounded px-3 py-2 text-sm" />
                  </div>
      
                  <div>
                    <label className="text-xs text-gray-500 uppercase">PAKAI</label>
                    <input value={form.PAKAI ?? ""}
                        onChange={(e) => { setForm({ ...form, PAKAI: e.target.value,})}}
                        className="w-full border rounded px-3 py-2 text-sm" />
                  </div>
      
                  <div>
                    <label className="text-xs text-gray-500 uppercase">VOLUME</label>
                    <input value={form.VOLUME ?? ""}
                        onChange={(e) => { setForm({ ...form, VOLUME: e.target.value,})}}
                        className="w-full border rounded px-3 py-2 text-sm" />
                  </div>
      
                  <div>
                    <label className="text-xs text-gray-500 uppercase">HAIR</label>
                    <input value={form.HAIR ?? ""}
                        onChange={(e) => { setForm({ ...form, HAIR: e.target.value,})}}
                        className="w-full border rounded px-3 py-2 text-sm" />
                  </div>
      
                  <div>
                    <label className="text-xs text-gray-500 uppercase">ADM</label>
                    <input value={form.ADM ?? ""}
                        onChange={(e) => { setForm({ ...form, ADM: e.target.value,})}}
                        className="w-full border rounded px-3 py-2 text-sm" />
                  </div>
      
                  <div>
                    <label className="text-xs text-gray-500 uppercase">DENDA</label>
                    <input value={form.DENDA ?? ""}
                        onChange={(e) => { setForm({ ...form, DENDA: e.target.value,})}}
                        className="w-full border rounded px-3 py-2 text-sm" />
                  </div>
      
                  <div>
                    <label className="text-xs text-gray-500 uppercase">SUBSIDI</label>
                    <input value={form.SUBSIDI ?? ""}
                        onChange={(e) => { setForm({ ...form, SUBSIDI: e.target.value,})}}
                        className="w-full border rounded px-3 py-2 text-sm" />
                  </div>
      
                  <div>
                    <label className="text-xs text-gray-500 uppercase">TOTAL</label>
                    <input value={form.TOTAL ?? ""}
                        readOnly
                      className="w-full border bg-gray-50 rounded px-3 py-2 text-sm" />
                  </div>

                  <div>
                    <label className="text-xs text-gray-500 uppercase">TOTAL BAYAR</label>
                    <input value={form.TOTAL_BYR ?? ""}
                        readOnly
                      className="w-full border bg-gray-50 rounded px-3 py-2 text-sm" />
                  </div>
                </div>
      
                <div className="flex items-center justify-end gap-3 pt-2">
                  <button type="button" onClick={onClose} className="px-4 py-2 rounded bg-gray-200">Cancel</button>
                  <button type="submit" onClick={() => handleSave(pelanggan?.nsb) } className="px-4 py-2 rounded bg-blue-600 text-white">Simpan</button>
                </div>
              </div>
            </div>
          </div>
        );
    }

    useEffect(() => {
      initDataPhotoMeter();
      setItemsPerPage(Number(statusLength === 'all' ? photoMeterData.length : statusLength))
    }, []);

    return (
      <>
        {/* Controls 1*/}
        <div className="bg-white rounded-xl shadow-lg p-6 mb-6">
            <div className="grid grid-cols-1 md:grid-cols-12 gap-4 items-center">
                {/* NSB */}
                <div className="col-span-1 md:col-span-2">
                <div className="relative">
                    <Filter className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
                    <select
                    value={statusFilter.nsb}
                    onChange={(e) => setStatusFilter({ ...statusFilter, nsb: e.target.value })}
                    className="pl-10 pr-3 py-2 border border-gray-300 rounded-lg w-full focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                    >
                    <option value="all">NSB</option>
                    {uniqueNsb.map((nsb, idx) => (
                        <option value={nsb} key={idx}>{nsb}</option>
                    ))}
                    </select>
                </div>
                </div>

                {/* Pelanggan */}
                <div className="col-span-1 md:col-span-2">
                <div className="relative">
                    <Filter className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
                    <select
                    value={statusFilter.status}
                    onChange={(e) => setStatusFilter({ ...statusFilter, status: e.target.value })}
                    className="pl-10 pr-3 py-2 border border-gray-300 rounded-lg w-full focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                    >
                    <option value="all">Pelanggan</option>
                    {uniqueStatus.map((item, idx) => (
                        <option value={item} key={idx}>{item}</option>
                    ))}
                    </select>
                </div>
                </div>

                {/* Klas */}
                <div className="col-span-1 md:col-span-2">
                  <div className="relative">
                      <Filter className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
                      <select
                      value={statusFilter.klasf}
                      onChange={(e) => setStatusFilter({ ...statusFilter, klasf: e.target.value })}
                      className="pl-10 pr-3 py-2 border border-gray-300 rounded-lg w-full focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                      >
                      <option value="all">Klas</option>
                      {uniqueKlas.map((klasf, idx) => (
                          <option value={klasf} key={idx}>{klasf}</option>
                      ))}
                      </select>
                  </div>
                </div>

                {/* Status (pakai) */}
                <div className="col-span-1 md:col-span-2">
                <div className="relative">
                    <Filter className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
                    <select
                    value={statusFilter.pelanggan}
                    onChange={(e) => setStatusFilter({ ...statusFilter, pelanggan: e.target.value })}
                    className="pl-10 pr-3 py-2 border border-gray-300 rounded-lg w-full focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                    >
                    <option value="all">Status</option>
                    {uniquePelanggan.map((item, idx) => (
                        <option value={item} key={idx}>{item}</option>
                    ))}
                    </select>
                </div>
                </div>

                {/* Kecamatan */}
                <div className="col-span-1 md:col-span-2">
                <div className="relative">
                    <Filter className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
                    <select
                    value={statusFilter.kecamatan}
                    onChange={(e) => setStatusFilter({ ...statusFilter, kecamatan: e.target.value })}
                    className="pl-10 pr-3 py-2 border border-gray-300 rounded-lg w-full focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                    >
                    <option value="all">Kecamatan</option>
                    {uniqueKecamatan.map((kecamatan, idx) => (
                        <option value={kecamatan} key={idx}>{kecamatan}</option>
                    ))}
                    </select>
                </div>
                </div>

                {/* Desa */}
                <div className="col-span-1 md:col-span-2">
                <div className="relative">
                    <Filter className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
                    <select
                    value={statusFilter.desa}
                    onChange={(e) => setStatusFilter({ ...statusFilter, desa: e.target.value })}
                    className="pl-10 pr-3 py-2 border border-gray-300 rounded-lg w-full focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                    >
                    <option value="all">Desa</option>
                    {uniqueDesa.map((desa, idx) => (
                        <option value={desa} key={idx}>{desa}</option>
                    ))}
                    </select>
                </div>
                </div>
            </div>
        </div>

        {/* Controls 2*/}
        <div className="bg-white rounded-xl shadow-lg p-6 mb-6">
          <div className="flex flex-col md:flex-row md:items-center md:justify-between space-y-4 md:space-y-0">
            <div className="flex flex-col md:flex-row space-y-4 md:space-y-0 md:space-x-4">
              {/* Filter */}
              <button 
                onClick={initDataPhotoMeter}
                disabled={loading}
                className="flex items-center px-4 py-2 text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200 transition-colors">
                <RotateCcw className={`w-4 h-4 mr-2 ${loading ? "animate-spin" : ""}`} />
                {loading ? "Memuat..." : "Muat Ulang"}
              </button>

              <ExportCSV  data={selectedPhotoMeter}/>
            </div>

            <div className="flex space-x-3">
              {/* Search */}
              <div className="relative">
                <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
                <input
                  type="text"
                  placeholder="Cari nama atau NIK..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  className="pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent w-full md:w-64"
                />
              </div>

              {/* Length*/}
              <div className="relative">
                <ListOrdered className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
                <select
                  value={statusLength}
                  onChange={(e) => {setStatusLength(e.target.value); setItemsPerPage(Number(e.target.value === 'all' ? photoMeterData.length : e.target.value))}}
                  className="pl-10 pr-8 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent w-full md:w-48"
                >
                  <option value="10">10</option>
                  <option value="50">50</option>
                  <option value="100">100</option> 
                  <option value="500">500</option>
                  <option value="all">Tampil Semua</option>
                </select>
              </div>
            </div>
          </div>
        </div>

        {/* Employee Table */}
        <div className="bg-white rounded-xl shadow-lg overflow-hidden">
          <div className="overflow-x-auto">
              <table className="table-auto min-w-full max-w-screen-lg divide-y divide-gray-200">
              <thead className="bg-gray-50">
                <tr>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    NO
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    NAMA
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    WILAYAH
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    KECAMATAN
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    DESA
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    KLASF
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    PELANGGAN
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    STATUS
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    PAKAI
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    TAHUN
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                  {
                    loading? 
                    <>
                      <tr>
                        <td colSpan={18} className="text-center py-4 text-gray-500">
                          Sedang Loading . . .
                        </td>
                      </tr>
                    </>
                    :
                    <>
                      <RenderTablePhotoMeterPelanggan filteredData={currentPhotoMeters} onOpenDetail={handleShowDetail} />
                    </>
                  }
              </tbody>
            </table>
          </div>
        </div>
  
        {/* Pagination */}
        <div className="mt-6 flex items-center justify-between">
        <div className="text-sm text-gray-700">
          Menampilkan <span className="font-medium">{currentPage}</span> hingga{' '}
          <span className="font-medium">{statusLength === "all" ? photoMeterData.length : statusLength}</span> dari{' '}
          <span className="font-medium">{photoMeterData.length}</span> karyawan
          <span className="font-medium">( Dari Sortir {filteredPhotoMeters.length} )</span>
        </div>
        <div className="flex space-x-2">
          <button 
          disabled={currentPage === 1}
          onClick={() => setCurrentPage(1)}
          className="px-3 py-2 text-sm text-gray-500 bg-white border border-gray-300 rounded-lg hover:bg-gray-50">
          First
          </button>
          <button 
          disabled={currentPage === 1}
          onClick={() => setCurrentPage(prev => prev - 1)}
          className="px-3 py-2 text-sm text-gray-500 bg-white border border-gray-300 rounded-lg hover:bg-gray-50">
          Previous
          </button>
          
          {pageNumbers
          .slice(
            Math.max(0, currentPage - 3), 
            Math.min(currentPage + 2, totalPages)
          )
          .map((page) =>( 
            <button 
            key={page}
            onClick={() => setCurrentPage(page)}
            className={`px-3 py-1 rounded ${ currentPage === page ? "bg-blue-500 text-white" : "bg-gray-200" }`}>
            {page}
            </button>
          ))}
          
          <button 
              disabled={currentPage === Math.ceil(filteredPhotoMeters.length / itemsPerPage)}
              onClick={() => setCurrentPage(prev => prev + 1)}
              className="px-3 py-2 text-sm text-gray-500 bg-white border border-gray-300 rounded-lg hover:bg-gray-50">
              Next
          </button>
          <button 
              disabled={currentPage === totalPages}
              onClick={() => setCurrentPage(totalPages)}
              className="px-3 py-2 text-sm text-gray-500 bg-white border border-gray-300 rounded-lg hover:bg-gray-50">
              Last
          </button>
        </div>
        </div>

        {showDetailModal && <DetailPreviewModal pelangganPMDetail={selectedPhotoMeter} stateShowModal={setShowDetailModal} />}
        {showEditModal && <EditModal show={showEditModal} onClose={() => { setShowEditModal(false); setShowDetailModal(true); } } tagihan={selectedTagihan} pelanggan={selectedPhotoMeter} onSubmit={(updated) => { console.log("Submit updated tagihan: ", updated); setShowEditModal(false);}} />}
      </>
    )
};